<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"
    *ngIf="isErrorMessageDisplay"></app-sg-aria-message>
<h1>担当作業一覧（供給停止・再開）</h1>
<form (ngSubmit)="onClickSearch($event)" [formGroup]="sgke331aReqForm">
    <app-sgke330d-condition *ngIf="todayDate" [todayDate]="todayDate">
    </app-sgke330d-condition>
</form>
<app-sgke330d-result *ngIf="searchresultList.length > 0" [searchresultList]="searchresultList"
    (onModalIsDisplayEvent)="onModalIsDisplay($event)">
</app-sgke330d-result>